import { createFileRoute } from '@tanstack/react-router';
import { fetchInternalOrderAttachments } from '@/api/orders';
import { OrderAttachmentsTab } from '@/app/(client)/orders/-components/OrderAttachmentsTab';
import { internalOrderAttachmentKeys } from '@/app/(client)/orders/-hooks/useInternalOrderAttachments';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/documents',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: internalOrderAttachmentKeys.detail(params.ioId),
      queryFn: () =>
        fetchInternalOrderAttachments(params.ioId).then(r => r.data),
    }),
  component: InternalOrderDocumentsRoute,
});

function InternalOrderDocumentsRoute() {
  const { ioId } = Route.useParams();
  return (
    <div className='h-full flex flex-col'>
      <OrderAttachmentsTab orderId={ioId} type='INTERNAL_ORDER' />
    </div>
  );
}
